export type EditorTool =
  | 'hand'
  | 'move'
  | 'pencil'
  | 'highlighter'
  | 'eraser'
  | 'rect'
  | 'circle'
  | 'arrow'
  | 'line'
  | 'text'
  | 'pin'
  | 'blur'
  | 'censor';

export type PinStyle = 'numbers' | 'letters-upper' | 'letters-lower';

export interface Point {
  x: number;
  y: number;
}

interface BaseAnnotation {
  id: string;
  color: string;
  lineWidth: number;
  opacity: number;
}

export interface PathAnnotation extends BaseAnnotation {
  kind: 'path';
  tool: 'pencil' | 'highlighter';
  points: Point[];
}

export interface ShapeAnnotation extends BaseAnnotation {
  kind: 'shape';
  tool: 'rect' | 'censor' | 'circle';
  x: number;
  y: number;
  width: number;
  height: number;
  fill: boolean;
}

export interface LineAnnotation extends BaseAnnotation {
  kind: 'line';
  tool: 'line' | 'arrow';
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export interface BlurAnnotation extends BaseAnnotation {
  kind: 'blur';
  tool: 'blur';
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface TextAnnotation extends BaseAnnotation {
  kind: 'text';
  tool: 'text';
  x: number;
  y: number;
  text: string;
  fontSize: number;
  bold: boolean;
  italic: boolean;
  hasBackground: boolean;
  backgroundColor: string;
}

export interface PinAnnotation extends BaseAnnotation {
  kind: 'pin';
  tool: 'pin';
  x: number;
  y: number;
  number: number;
  label: string;
}

export type Annotation =
  | PathAnnotation
  | ShapeAnnotation
  | LineAnnotation
  | BlurAnnotation
  | TextAnnotation
  | PinAnnotation;

export interface TextInputState {
  canvasX: number;
  canvasY: number;
  screenX: number;
  screenY: number;
}

export interface ImageFeedbackEditorProps {
  imageSrc: string;
  onSave: (editedImageBase64: string) => void;
  onCancel: () => void;
  onDownload?: (editedImageBase64: string) => void;
  hidden?: boolean;
  theme?: 'light' | 'dark';
  accentColor?: string;
  className?: string;
}

export const PRESET_COLORS = [
  '#EF4444',
  '#F97316',
  '#EAB308',
  '#22C55E',
  '#06B6D4',
  '#3B82F6',
  '#8B5CF6',
  '#EC4899',
  '#FFFFFF',
  '#D1D5DB',
  '#6B7280',
  '#111827',
];
